// export const TWITTER_LINK = '';
// export const LINKEDIN_LINK = '';
// export const FACEBOOK_LINK = '';
// export const INSTAGRAM_LINK = '';
// export const TIKTOK_LINK = '';
export const YOUTUBE_LINK = 'https://www.youtube.com/@Piotr-bo9il';
export const TELEGRAM_LINK = 'https://t.me/hittheyield';
